import DialogBase from "../libs/DialogBase";
import Splide from '@splidejs/splide';

export default class DialogGallery extends DialogBase {
  constructor() {
    super("#dialog_gallery");

    this.CL_ACTIVE = 'isActive';
    this.isRefreshed = false;

    document.querySelectorAll('.js-dialog_gallery').forEach(el=>{
      el.addEventListener('click',(e)=>{
        const target = e.currentTarget;
        this.onClickOpen(target.dataset.index);
      });
    });

    this.scrollTarget = this.target.querySelector('.-sub');

    this.thumnail = this.target.querySelectorAll('.-sub ul li button');

    this.thumnail.forEach(el=>{
      el.addEventListener('click',el=>{
        const index = parseInt(el.currentTarget.dataset.index);
        this.splide.options = { speed: 0 };
        this.splide.go(index);
        this.splide.options = { speed: 400 };
      });
    });


    this.splideEl = this.target.querySelector('.splide');
    this.splide = new Splide(this.splideEl,{
      width: '100%',
      height: '100%',
      rewind: true,
      pagination: false,
      arrows: true,
      flickPower: 100,
    });

    const current = this.target.querySelector('.-main .-count .-current');
    const total   = this.target.querySelector('.-main .-count .-total');
    this.splide.on('mounted move',  ()=> {
      current.textContent = this.splide.index + 1;
      total.textContent   = this.splide.length;

      this.thumnail.forEach(el=>{el.classList.remove(this.CL_ACTIVE);});
      const thums = this.thumnail[this.splide.index];
      thums.classList.add(this.CL_ACTIVE);

      const imgRect = thums.getBoundingClientRect();
      const containerRect = this.scrollTarget.getBoundingClientRect()

      if(imgRect.bottom < containerRect.top ||
        imgRect.top > containerRect.bottom){
        thums.scrollIntoView({behavior: 'smooth', block: 'start'});
      }
    });

    this.splide.mount();
  }

  onClickOpen(_index = 0){
    this.firstIndex = parseInt(_index);
    this.onOpen();
  }

  onOpenBefore() {
    super.onOpenBefore();

    if (Number.isFinite(this.firstIndex)) {
      this.splide.options = { speed: 0 };
      if (this.isRefreshed) {
        this.splide.go(this.firstIndex);
      }
    }
  }

  onOpenAfter() {
    super.onOpenAfter();

    if (!this.isRefreshed) {
      this.splide.go(this.firstIndex);
      this.isRefreshed = true;
    }

    this.splide.options = { speed: 400 };

    if (this.thumnail[this.firstIndex]) {
      this.thumnail[this.firstIndex].scrollIntoView();
    }
  }

  onOpen() {
    super.onOpen();
  }
}
